import React, {Component} from 'react'
import { CloseIcon } from '../../Svg/Index.js'
import LightboxPopup from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

class Lightbox extends Component {

    render() {
        const { active, source } = this.props;
        if(!active)
            return false
            
        return (
            <LightboxPopup
                mainSrc={source}
                onCloseRequest={this.props.handleLightboxClose}
            />
        )
    }
}

export default Lightbox